export function initAnimations() {
    const brand = document.querySelector(".navbar-brand");
    const logo_spin = document.querySelector("#logo_spin");
    brand.addEventListener("mouseenter", () => {
        logo_spin.className.baseVal = "logo-spin-in";
    });
    brand.addEventListener("mouseleave", () => {
        logo_spin.className.baseVal = "logo-spin-out";
    });
    fadeInColumns();
}
function fadeInColumns() {
    const rows = [...document.querySelectorAll(".row")];
    // callback function for when each row is visible
    function callback(entries) {
        entries.forEach((change) => {
            const row = change.target;
            if (change.isIntersecting) {
                row.classList.add("visible");
                const columns = row.querySelectorAll("[class*='col-']:not(.no-fade)");
                columns.forEach((column, index) => {
                    setTimeout(() => {
                        column.classList.add("visible");
                    }, index * 100);
                });
            }
        });
    }
    const observer = new IntersectionObserver(callback, {
        threshold: 0,
    });
    // remove old observers
    observer.disconnect();
    rows.forEach((row) => observer.observe(row));
}
